/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import { compose } from '@wordpress/compose'
import { RichText } from '@wordpress/block-editor'
import { applyFilters } from '@wordpress/hooks'

/**
 * Internal dependencies
 */
import { name } from './index'

/**
 * External dependencies
 */
import classnames from 'classnames'
import { 
	ButtonEditHelper, ImageUploadPlaceholder
} from '~cartzillagb/components'

const save = props => {
	const { 
		attributes, 
		className,
	} = props 

	const {
		badge,
		pretitle,
		enableBadge,
		enablePretitle,
		enableTitle,
		enableSubtitle,
		enableButton,
		badgecolor,
		custombadgecolor,
		title,
		subTitle,
		mediaURL,
		bgcolor,
		custombgcolor,
		date,
		daysLabel,
        hoursLabel,
        minsLabel,
        secsLabel,
        enableTimer
	} = attributes


	let d = new Date(date);

	d.setDate(d.getDate());

	function addZero(i) {
		if (i < 10) {
			i = "0" + i;
		}
		
		return i;
	}

	function timeFunction() {
		const h = addZero(d.getHours());
		const m = addZero(d.getMinutes());
		const s = addZero(d.getSeconds());
		const time = ' ' + h + ':' + m + ':' + s;

		return time
	}

	const currentDate = new Date(); // Current date now.

	const mainClasses = classnames( [
		className,
	], applyFilters( `cartzillagb.${ name.replace( 'czgb/', '' ) }.main-block.classes`, {}, props ) )

	const bgstyle = { backgroundColor: custombgcolor && custombgcolor }

	return (
		<div className={ mainClasses }>
			<section className="container mt-4 mb-grid-gutter">
				<div className={ `rounded-lg py-4 ${ bgcolor ? bgcolor : custombgcolor ? '' : 'bg-faded-info' }` } style={ bgstyle } >
					<div className="row align-items-center">
						<div className="col-md-5">
							<div className="px-4 pr-sm-0 pl-sm-5">
								{ enableBadge &&
									<RichText.Content
										tagName="span"
										className={ `badge ${ badgecolor ? badgecolor : custombadgecolor ? '' : 'badge-danger' }` } 
										value={ badge || 'Limited Offer' }
										style={ { color: custombadgecolor } }
									/>
								}
								{ enablePretitle && 
									<RichText.Content
										tagName="h3"
										className={ `mt-4 mb-1 font-weight-light text-body` }
										value={ pretitle || 'All New' }
									/>
								}
								{ enableTitle && 
									<RichText.Content
										tagName="h2"
										className={ `mb-1 text-dark` } 
										value={ title || 'Last Gen iPad Pro' }
									/>
								}
								{ enableSubtitle && 
									<RichText.Content
										tagName="p"
										value={ subTitle || 'at discounted price. Hurry up!' }
										className={ `h5 font-weight-light text-body` }
									/>
								}
								{ d.getTime() > currentDate.getTime() && enableTimer &&
									<div className="cz-countdown py-2 h4" data-countdown={ ("0" + (d.getMonth() + 1)).slice(-2) + '/' + ("0" + d.getDate()).slice(-2) + '/' + d.getFullYear() + timeFunction() }>
										<div className="cz-countdown-days">
											<span className="cz-countdown-value"></span>
											<span className="cz-countdown-label text-muted">{ daysLabel }</span>
										</div>
										<div className="cz-countdown-hours">
											<span className="cz-countdown-value"></span>
											<span className="cz-countdown-label text-muted">{ hoursLabel }</span>
										</div>
										<div className="cz-countdown-minutes">
											<span className="cz-countdown-value"></span>
											<span className="cz-countdown-label text-muted">{ minsLabel }</span>
										</div>
										<div className="cz-countdown-seconds">
											<span className="cz-countdown-value"></span>
											<span className="cz-countdown-label text-muted">{ secsLabel }</span>
										</div>
									</div>
								}
								{ enableButton &&
									<ButtonEditHelper.Content
										attrNameTemplate={ `button1%s` }
										blockAttributes={ props.attributes }
									/>
								}
							</div>
						</div>
						<div className="col-md-7">
							<ImageUploadPlaceholder
								imageURL={ mediaURL }
								render={ <img src={ mediaURL } alt={ __( 'iPad Pro Offer' ) } /> }
							/>
						</div>
					</div>
				</div>
			</section>
		</div>
	)
}

export default compose(
)( save )